module.exports = __webpack_public_path__ + "static/img/12.be893a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/12.png
// module id = v5KC
// module chunks = 0